export default "__VITE_ASSET__BuZ84t4o__"